const format = (number, locale = "es-MX") => {
    return new Intl.NumberFormat(locale).format(number);
}

export default {
    format
};